const account_center = {
    not_enabled: 'Account Center ist nicht aktiviert.',
    field_not_editable: 'Feld ist nicht bearbeitbar.',
};
export default Object.freeze(account_center);
